import React from "react";
import { Route, BrowserRouter, Redirect } from "react-router-dom";
import Login from "./public/login/Login";

import Dashboard from "./private/dashboard/Dashboard";
import Item1 from "./private/item1/Item1";
import Item2 from "./private/item2/Item2";
import Settings from "./private/settings/Settings";

function Routes() {
  function PrivateRoute({ children, ...rest }) {
    return (
      <Route
        {...rest}
        render={() => {
          return localStorage.getItem("token") ? children : <Redirect to="/login" />;
        }}
      />
    );
  }

  return (
    <BrowserRouter>
      <Route path="/" exact>
        <Login />
      </Route>
      <Route path="/login" exact>
        <Login />
      </Route>
      <PrivateRoute path="/dashboard">
        <Dashboard />
      </PrivateRoute>
      <PrivateRoute path="/item1">
        <Item1 />
      </PrivateRoute>
      <Route path="/item2">
        <Item2 />
      </Route>
      <Route path="/settings">
        <Settings />
      </Route>
    </BrowserRouter>
  );
}

export default Routes;
